import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class ExternalValidationsService{
  private currentErrors: models.WorkflowValidationsVM;
  public errorsChangedSubject: Subject<models.WorkflowValidationsVM>;

  constructor() {
    this.currentErrors = { stepValidationsResult: [] as models.WorkflowStepValidationsVM[] } 
    this.errorsChangedSubject = new Subject<models.WorkflowValidationsVM>();
  }

  public setStepExternalErrors(errors: models.WorkflowStepValidationsVM) {
    _.remove(this.currentErrors.stepValidationsResult, stepErrors => stepErrors.stepCode === errors.stepCode);
    this.currentErrors.stepValidationsResult = this.currentErrors.stepValidationsResult.concat(errors);
    this.errorsChangedSubject.next(this.currentErrors);
  }
  public setExternalErrors(errors: models.WorkflowValidationsVM) {
    this.currentErrors = errors;
    this.errorsChangedSubject.next(this.currentErrors);
  }

  //Ainda não é usado, as infos necessárias para chamar este método são dificeis de ober,
  //dentro dos cartoes de edit das tabelas,
  //precisa mais investigação
  public removeErrorFromTableLine(stepCode: string, cardCode: string, fieldName: string, tableIndex: number) {
    const stepIndex = this.currentErrors.stepValidationsResult.findIndex(x => x.stepCode == stepCode);
    if (stepIndex != -1) {
      const removedItems = _.remove(this.currentErrors.stepValidationsResult[stepIndex].errors, x => x.cardCode == cardCode && x.fieldName == fieldName && (x.tableLineNumber - 1 )== tableIndex);
      if (removedItems.length > 0)
        this.errorsChangedSubject.next(this.currentErrors);
    }
  }

  public getCurrentErrors() {
    return this.currentErrors;
  }
}
